import { useEffect, useState } from "react";
import { AddressInputNew } from "../../components/AddressInputNew";
import CheckboxSimple from "../../components/CheckboxSimple";
import InputText from "../../components/InputText";
import { formFields } from "./columns";
import { useGetSubdivisionListQuery } from "../../../middleware/usersApi";
import { SelectMultipleWithClientSearch } from "../../components/SelectSimple/SelectMultipleWithClientSearch";
import { formatAddress } from "../../../helpers/helper";
import { ServiceAreasFields } from "./ServiceAreas";

export const basicInformationConfig = (isGroup) => [
  {
    id: 1,
    name: formFields.name,
    label: "Название подразделения",
    type: "text",
    firstUpperCase: true,
    placeholder: "Введите название",
    flexBasis: "100%",
    isVisible: true,
    rules: {
      required: true,
    },
    input: (props) => <InputText {...props} />,
  },
  {
    id: 2,
    name: formFields.isGroup,
    label: "Группа подразделения",
    type: "checkbox",
    isVisible: true,
    rules: {},
    flexBasis: "100%",
    input: (props) => <CheckboxSimple {...props} />,
  },
  {
    id: 3,
    name: formFields.serviceAreas,
    rules: {
      required: true,
    },
    flexBasis: "49%",
    isVisible: !isGroup,
    CustomFormItem: ServiceAreasFields,
  },

  {
    id: 4,
    name: formFields.subdivisionIds,
    label: "label:subdivisionInGroup",
    flexBasis: "100%",
    placeholder: "Выберите подразделении",
    isVisible: isGroup,
    rules: {
      required: true,
    },
    input: (props) => <SubdivisionSelect {...props} />,
  },
];

export const SubdivisionSelect = (props) => {
  const [subdivisionsOptions, setSubdivisionsOptions] = useState([]);
  const { data = [] } = useGetSubdivisionListQuery({});

  useEffect(() => {
    if (!data.length) return;

    const formattedSubdivisionsList = data.map((item) => {
      return {
        id: item.id,
        name: `${item.name}, ${formatAddress(item.addressDto)}`,
      };
    });

    setSubdivisionsOptions(formattedSubdivisionsList);
  }, [data]);

  return <SelectMultipleWithClientSearch isIds={true} displayEmpty={true} options={subdivisionsOptions} {...props} />;
};
